export default __webpack_public_path__ + "static/media/n3.73ceeccb.jpg";